import React, { FunctionComponent } from 'react';

import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme/ScopedTheme';

import ModalWithHeader from '../../../components/modal-with-header';
import { i18n } from '../../../helpers/i18n';
import { SettingsMenu } from '../components/menu';
import type { SettingsComponentProps } from '../types';
import css from './styles.css';

export const SettingsDesktop: FunctionComponent<SettingsComponentProps> = ({
    parentRef,
    visible = true,
    onClose,
    availableMenuItems,
    selectedItem,
    setSelectedItem,
}) => {
    return (
        <ScopedTheme theme="dark">
            <ModalWithHeader
                parentRef={parentRef}
                onClose={onClose}
                visible={visible}
                title={i18n('settings', 'title')}
                keepMounted={false}
            >
                <div className={css.contentContainer}>
                    <SettingsMenu
                        menuItems={availableMenuItems}
                        selectedItem={selectedItem}
                        onSelectedItemChange={setSelectedItem}
                    />
                    <div className={css.content}>{selectedItem && <selectedItem.section />}</div>
                </div>
            </ModalWithHeader>
        </ScopedTheme>
    );
};
